import { CompensationVoucher } from '../../models/home';
import { GROUPS, getGroupFromRoles } from '../../constants/authGroups';
import { useAuthProvider } from '../../providers/AuthProvider';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    compensationVouchers: CompensationVoucher[];
}

export const useConfirmation = ({compensationVouchers}: Props) => {
    const authContext = useAuthProvider();
    const { t } = useTranslation();

    const [compVouchersWithCode, setCompVouchersWithCode] = useState<CompensationVoucher[]>([]);
    const [inFlightUser, setInFlightUser] = useState<boolean>(false);
    const [isNtpVoucherCode, setIsNtpVoucherCode] = useState<boolean>(false);
    const [hidePopUp, setHidePopUp] = useState<boolean>(false);
    const [voucherCount, setVoucherCount] = useState<number>(0);

    useEffect(() => {
        if (
            authContext.user.roles.length
            && getGroupFromRoles(authContext.user.roles) === GROUPS.inFlight.name
        ) {
            setInFlightUser(true);
        }

    }, [authContext.user.roles]);

    useEffect(() => {
        let validVouchersWithCode: CompensationVoucher[] = [];
        compensationVouchers.forEach(voucher => {
            if (voucher?.errorCode === 200) {
                validVouchersWithCode.push(voucher);
            }
            if (voucher?.type !== 'Wi-Fi') {
                setIsNtpVoucherCode(true);
            } else {
                setIsNtpVoucherCode(false);
            }
        })
        setCompVouchersWithCode(validVouchersWithCode);

    }, [compensationVouchers]);

    const handleOnClickShowNextCode = () => {
        setVoucherCount(voucherCount + 1);
    };

    window.scrollTo({top: 0});

    return {
        compVouchersWithCode,
        hidePopUp,
        inFlightUser,
        isNtpVoucherCode,
        voucherCount,
        handleOnClickShowNextCode,
        setHidePopUp,
        t
    };
};

